import angular from 'angular';

import { UIA_MODAL_WORKFLOW } from '@uia/uia-workflow/uia-workflow-constants';

const setCurrentWorkflow = (currentWorkflow, previousWorkflow) => {
  return {
    type: UIA_MODAL_WORKFLOW.SET_CURRENT_WORKFLOW,
    payload: {
      currentWorkflow,
      previousWorkflow,
    },
  };
};

const setCurrentIndex = (newIndex: number) => {
  return {
    type: UIA_MODAL_WORKFLOW.SET_CURRENT_INDEX,
    payload: newIndex,
  };
};

export default {
  setCurrentWorkflow,
  setCurrentIndex,
};

angular.module('curalate').service('UniversalImageActionsWorkflowActions', [
  function() {
    this.setCurrentWorkflow = setCurrentWorkflow;
    this.setCurrentIndex = setCurrentIndex;
  },
]);
